export default __webpack_public_path__ + "static/media/leftArrow.7905331b.svg";